import React, { Suspense, lazy, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Spinner from './components/Spinner';
// Lazy load the RoutesComponent
const Routes = lazy(() => import('./routes'));

/**
 * Main application component that sets up routing and lazy loading.
 * @function App
 * @returns {Import(react).JSX.Element} The application component wrapped with a router and suspense fallback.
 */

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <Suspense fallback={<Spinner />}>
      <ScrollToTop /> {/* This handles scroll behavior */}
      <Routes /> {/* Lazy-loaded RoutesComponent */}
    </Suspense>
  );
};

export default App;
